(function(){
  'use strict';

  /* ── Header scroll ──────────────────────────── */
  var ann=document.querySelector('.ann'),hdr=document.querySelector('.hdr');
  window.addEventListener('scroll',function(){
    if(!hdr)return;
    if(ann&&window.scrollY>ann.offsetHeight+10){ann.style.display='none';hdr.classList.add('no-ann');}
    hdr.classList.toggle('lifted',window.scrollY>40);
  },{passive:true});

  /* ── Mobile nav ─────────────────────────────── */
  var burger=document.getElementById('Burger'),
      mobNav=document.getElementById('MobNav'),
      mobX=document.getElementById('MobX');
  function openNav(){if(mobNav){mobNav.classList.add('open');document.body.style.overflow='hidden';}}
  function closeNav(){if(mobNav){mobNav.classList.remove('open');document.body.style.overflow='';}}
  if(burger)burger.addEventListener('click',openNav);
  if(mobX)mobX.addEventListener('click',closeNav);

  /* ── Cart count ─────────────────────────────── */
  function refreshCount(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('.cart-pip').forEach(function(el){
        el.textContent=c.item_count;
        el.style.display=c.item_count>0?'inline-flex':'none';
      });
    }).catch(function(){});
  }
  refreshCount();

  /* ── Add to cart ────────────────────────────── */
  document.querySelectorAll('[data-atc]').forEach(function(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('.atc');
      if(!btn||btn.disabled)return;
      var orig=btn.textContent;
      btn.textContent='ADDING...';btn.disabled=true;
      fetch('/cart/add.js',{method:'POST',body:new FormData(form)})
        .then(function(r){return r.json();})
        .then(function(){
          btn.textContent='ADDED \u2713';refreshCount();
          setTimeout(function(){btn.textContent=orig;btn.disabled=false;},1400);
        })
        .catch(function(){btn.textContent=orig;btn.disabled=false;});
    });
  });

  /* ── Variant pills ──────────────────────────── */
  document.querySelectorAll('.v-group').forEach(function(g){
    g.querySelectorAll('.v-pill').forEach(function(p){
      p.addEventListener('click',function(){
        g.querySelectorAll('.v-pill').forEach(function(x){x.classList.remove('on');});
        this.classList.add('on');
        var vi=document.getElementById('VarId'),pp=document.getElementById('PdpPrice');
        if(vi&&this.dataset.vid)vi.value=this.dataset.vid;
        if(pp&&this.dataset.price)pp.textContent=this.dataset.price;
      });
    });
  });

  /* ── Product gallery thumbs ─────────────────── */
  var mainImg=document.getElementById('MainImg');
  document.querySelectorAll('.pdp__thumb').forEach(function(btn){
    btn.addEventListener('click',function(){if(mainImg&&this.dataset.src)mainImg.src=this.dataset.src;});
  });

  /* ── Newsletter ─────────────────────────────── */
  document.querySelectorAll('[data-nl]').forEach(function(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var inp=form.querySelector('input[type=email]'),btn=form.querySelector('.nl__btn');
      if(!inp||!inp.value)return;
      var orig=btn.textContent;
      btn.textContent='Done \u2713';btn.disabled=true;inp.value='';
      setTimeout(function(){btn.textContent=orig;btn.disabled=false;},3500);
    });
  });

  /* ── Scroll reveal for product cards ────────── */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.style.opacity='1';
          e.target.style.transform='translateY(0)';
          io.unobserve(e.target);
        }
      });
    },{threshold:0.1,rootMargin:'0px 0px -40px 0px'});
    document.querySelectorAll('.pcard,.mission__cell,.why__cell').forEach(function(el){
      el.style.opacity='0';
      el.style.transform='translateY(24px)';
      el.style.transition='opacity 0.6s ease, transform 0.6s ease';
      io.observe(el);
    });
  }

})();
